import { useState } from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { panels } from "components/CancelRequest/CancelRequestPanels";
import { PanelFlow } from "components/PanelFlow";

import { CancelPanelKey } from "~components/CancelRequest/constants";
import { translate } from "~utils";

import type { CancelModalProps, CancelRequestState } from "./types";

export const CancelRequestModal: React.FC<CancelModalProps> = ({
  request,
  onDismiss,
  onSubmit,
}) => {
  const [cancelRequestState, setCancelRequestState] = useState<CancelRequestState>({
    cancelReason: undefined,
    cancelExplanation: "",
    shouldRepost: undefined,
    response: undefined,
    request,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <IonPage>
      <IonHeader mode="md">
        <IonToolbar mode="md">
          <IonTitle>{translate("CANCEL_REQ_LABEL_HEADER")}</IonTitle>
          <IonButtons slot="end">
            <IonButton fill="clear" strong onClick={onDismiss}>
              {translate("LABEL_CLOSE")}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <PanelFlow
          panels={panels}
          defaultPanelKey={CancelPanelKey.CancelReasonPanel}
          state={cancelRequestState}
          setState={setCancelRequestState}
          extraProps={{
            request,
            onDismiss,
            onSubmit,
            isSubmitting,
            setIsSubmitting,
          }}
        />
      </IonContent>
    </IonPage>
  );
};
